const COMPONENT = {
  DEFAULT: {
    LOGIN: {
      OTP: {
        EXPIRATION_TIME: 2.5 * 60,
      },
      TERMS: {
        AGREEMENT:
          'با ورود و یا ثبت نام در فروشگاه کاشی لند، شما شرایط و قوانین استفاده از تمام سرویس های سایت کاشی لند و قوانین حریم خصوصی آن را می‌پذیرید.',
      },
    },
  },
} as const;

export { COMPONENT };
